// @flow

import React, { type Node } from 'react';
import { Helmet } from 'react-helmet';

import { PaymentSpecProvider } from '@tectonics/prs/payment-spec';
import { IncomingPaymentProvider } from '@tectonics/prs/incoming-payment';
import { UserInputValuesProvider } from '@tectonics/prs/user-input-values';
import type { LookAndFeelRootPropsOpenedPayment } from '@tectonics/look-and-feel';
import { ValidationProvider } from '@tectonics/prs/validation';
import { AppValuesProvider } from '@tectonics/app-values';
import { SubmittingProvider } from '@tectonics/prs/submitting';
import { FormStatusContextProvider } from '@tectonics/prs/form-status';
import faviconSrc from '@tectonics/favicon.svg';

type Props = {
  ...LookAndFeelRootPropsOpenedPayment,
  children: Node,
};

export function ContextProvider({ children, ...context }: Props): Node {
  return (
    <PaymentSpecProvider spec={context.spec}>
      <IncomingPaymentProvider incomingPayment={context.incomingPayment}>
        <AppValuesProvider appValues={context.appValues} setAppValues={context.setAppValues}>
          <UserInputValuesProvider values={context.userInputValues} setValue={context.onUserInput}>
            <ValidationProvider
              userInputValidationErrors={context.userInputValidationErrors}
              submitError={context.submitError}
            >
              <SubmittingProvider submitting={context.submitting}>
                <FormStatusContextProvider>
                  <Helmet
                    title="Página de pagamento - Uber"
                    link={[{ rel: 'icon', href: faviconSrc }]}
                  />
                  {children}
                </FormStatusContextProvider>
              </SubmittingProvider>
            </ValidationProvider>
          </UserInputValuesProvider>
        </AppValuesProvider>
      </IncomingPaymentProvider>
    </PaymentSpecProvider>
  );
}
